import { Col } from "antd";

export default function ColResponsive({children}) {
    return (
        <Col xs={24} sm={12} md={8} xl={4} >
            {children}
        </Col>
    )
}
